<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Accueil" v-if="messageAccueil">
        <div v-html="messageAccueil"></div>
      </BaseBlock>
    </v-col>

    <div v-if="processusBool && user.roles.includes('PERSONNEL')">
      <Tuiles :processusKeys="processusKeys" :processus="processus"></Tuiles>
    </div>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import BaseBlock from "@/components/base/BaseBlock";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import ApiProcessusRepository from "@/repositories/ApiProcessusRepository";
import Tuiles from "@/components/Tuiles";

export default {
  name: "Home",
  components: { BaseBlock, Tuiles },
  data() {
    return {
      messageAccueil: null,
      processus: null,
      processusCount: null,
      processusKeys: null,
      processusBool: false,
    };
  },
  computed: {
    ...mapState(["user", "isAuthenticated"]),
  },
  async mounted() {
    this.messageAccueil = await ApiRefMessageRepository.getMessageAccueil();
    if (this.$store.state.user != null) {
      this.processus = await ApiProcessusRepository.getAllPersonnelinMap();
      this.processusKeys = Object.keys(this.processus);
      this.processusCount = await ApiProcessusRepository.getAllCount();
      this.addCount();
    }
  },
  async created() {},
  methods: {
    addCount() {
      for (var i of this.processusKeys) {
        for (var e of this.processus[i]) {
          const processusCountKeys = Object.keys(this.processusCount);
          for (var a of processusCountKeys) {
            if (e.id == a) {
              e.count = this.processusCount[a];
            }
          }
        }
      }
      this.processusBool = true;
    },
  },
};
</script>
